module.exports = __webpack_public_path__ + "media/images/program/stress_triangle-b1ef4df1b26bfa06e5e65b86dfb20e4839b4dd90150a965c1d10781d4aaa460d.png";